import { render } from "./page-videocamera.vue?vue&type=template&id=53785180&scoped=true"
import script from "./page-videocamera.vue?vue&type=script&lang=js"
export * from "./page-videocamera.vue?vue&type=script&lang=js"

import "./page-videocamera.vue?vue&type=style&index=0&id=53785180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53785180"]])

export default __exports__